const url = '/credit-companies';
const Provider = 'CreditCompanies';
const dbModel = 'CreditCompanies';

export { url, Provider, dbModel };
